export default __webpack_public_path__ + "static/media/M1A_7.772e0f41.png";